export const BRAND = {
  name: "All Thrive Therapy and Consulting, PLLC",
  shortName: "All Thrive",
  tagline: "Compassionate, Person-Centered Therapy",
  phone: "+1 479.430.0744",
  phoneHref: "+14794300744",
  fax: "(479) 546-2299",
  email: "info@allthrivepllc.com",
  website: "www.allthrivepllc.com",
  websiteHref: "https://www.allthrivepllc.com",
  address: "65 E Sunbridge Drive, Fayetteville, AR 72703",
  logo: "/allthrive_logo.png",
  logoRemote: "https://customer-assets.emergentagent.com/job_caregiver-support-3/artifacts/ii7zal2n_ALLThrive_Logo_05.png",
  logoAlt: "https://customer-assets.emergentagent.com/job_caregiver-support-3/artifacts/grckkoer_ALLThrive_Logo_04.png",
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/contact" },
];

/* Diverse imagery — explicitly varied races (Black, White, Asian, Latina/o) */
export const AUDIENCES = [
  {
    id: "children-teens",
    title: "Children & Teens",
    description:
      "Navigating school stress, big emotions, sensory differences, anxiety, and social challenges.",
    tags: ["School Stress", "Sensory", "Anxiety", "Friendships"],
    image:
      "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1200&q=80",
    accent: "olive",
  },
  {
    id: "adults",
    title: "Adults",
    description:
      "Managing life transitions, workplace overwhelm, depression, ADHD, and identity exploration.",
    tags: ["ADHD", "Depression", "Transitions", "Identity"],
    image:
      "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=1200&q=80",
    accent: "teal",
  },
  {
    id: "couples-families",
    title: "Couples & Families",
    description:
      "Mending relational issues, building stronger communication, and restoring peace at home.",
    tags: ["Communication", "Conflict", "Connection"],
    image:
      "https://images.unsplash.com/photo-1609220136736-443140cffec6?auto=format&fit=crop&w=1200&q=80",
    accent: "sand",
  },
  {
    id: "caregivers",
    title: "Caregivers",
    description:
      "Prioritizing caregiver wellness, preventing burnout, and finding tools that truly replenish.",
    tags: ["Burnout", "Boundaries", "Self-Care"],
    image:
      "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&w=1200&q=80",
    accent: "navy",
  },
];

/* Reframed around the new content — Anxiety + Depression as primary clinical specialties,
   joined by Neurodiversity-Affirming Care and Caregiver & Family Support. */
export const FOCUS_AREAS = [
  {
    id: "anxiety",
    title: "Anxiety Disorders",
    body:
      "Persistent worry, panic, social anxiety, health fears, or overwhelming stress — together we'll identify patterns, build emotional resilience, and create practical tools so you can re-engage with the life you want to live.",
    icon: "HeartPulse",
  },
  {
    id: "depression",
    title: "Depression & Emotional Wellness",
    body:
      "When even simple tasks feel heavy, therapy offers a compassionate space to feel heard. Together we'll explore what's contributing to low mood and rebuild hope, motivation, and clarity.",
    icon: "Sprout",
  },
  {
    id: "neurodiversity",
    title: "Neurodiversity-Affirming Care",
    body:
      "Care that honors how your brain actually works — especially for ADHD, autism, and sensory differences. I focus on self-awareness, self-compassion, and strategies that fit your real life.",
    icon: "Brain",
  },
  {
    id: "caregivers",
    title: "Caregiver & Family Support",
    body:
      "Compassionate support for parents and caregivers to process burnout, build boundaries, and strengthen the family system — alongside the person they care for.",
    icon: "Users",
  },
];

export const TOOLKIT = [
  {
    title: "Person-Centered Therapy",
    body:
      "Grounded in a genuine, trusting relationship. You set the pace; I honor your story without judgment and without a one-size-fits-all template.",
    label: "Person-Centered",
  },
  {
    title: "Cognitive Behavioral Therapy (CBT)",
    body:
      "Identify and shift unhelpful thought patterns. Build practical, evidence-based strategies for managing daily stress, anxiety, and depression.",
    label: "CBT",
  },
  {
    title: "Dialectical Behavior Therapy (DBT)",
    body:
      "Strengthen emotional regulation, distress tolerance, and interpersonal effectiveness — real-time tools that support lasting change.",
    label: "DBT",
  },
];

export const PARTNERS = [
  { name: "Medical Coordination", icon: "Stethoscope" },
  { name: "Nutritional Support", icon: "Apple" },
  { name: "Occupational Therapy", icon: "HandHeart" },
  { name: "Holistic Wellness", icon: "Leaf" },
  { name: "Speech & Language", icon: "MessageCircleHeart" },
  { name: "Psychiatry Referrals", icon: "HeartHandshake" },
];

export const PHILOSOPHY_PILLARS = [
  {
    title: "Person-Centered",
    body:
      "A genuine, trusting therapeutic relationship is the foundation. I move at your pace and honor your lived experience.",
  },
  {
    title: "Evidence-Based",
    body:
      "I integrate CBT, DBT, and other proven approaches — tailored to your goals rather than a fixed protocol.",
  },
  {
    title: "Neurodiversity-Affirming",
    body:
      "I celebrate how your unique brain works and build strategies that fit your real life, not the other way around.",
  },
];

export const THERAPY_FOR_OPTIONS = [
  { value: "adult", label: "Myself (Adult)" },
  { value: "child_teen", label: "My Child / Teen" },
  { value: "caregiver", label: "Myself as a Caregiver" },
  { value: "family_relationship", label: "Our Family / Relationship" },
];

export const FAQ_CATEGORIES = [
  {
    id: "getting-started",
    title: "Getting Started",
    blurb:
      "Your first steps with All Thrive — what to expect, how to book, and how things flow.",
    icon: "Sparkles",
    items: [
      {
        q: "How do I begin therapy with you?",
        a: "The easiest way is to fill out the brief contact form on this site or send a note to info@allthrivepllc.com. I'll respond within one business day to schedule a free 15-minute consultation so we can talk through what's bringing you in and make sure we're a good fit.",
      },
      {
        q: "What happens in the first session?",
        a: "The first session is mostly about getting to know each other. I'll ask about what you're hoping to work on, your history, and what's been most helpful (or unhelpful) in the past. There's no pressure to share more than you're ready to — we move at your pace.",
      },
      {
        q: "How long are sessions?",
        a: "Standard sessions are 50 minutes. For some clients — especially children, teens, and families — I sometimes offer 30- or 75-minute formats depending on what serves you best. We'll decide what fits during our consultation.",
      },
      {
        q: "How often will I meet with you?",
        a: "Most clients start with weekly sessions, which tend to build the strongest momentum. As progress takes hold, many shift to every other week or monthly check-ins. Frequency is always your choice and adjustable along the way.",
      },
    ],
  },
  {
    id: "services-approach",
    title: "Services & Approach",
    blurb:
      "What I treat, how I work, and the modalities I draw from.",
    icon: "HeartPulse",
    items: [
      {
        q: "What ages do you work with?",
        a: "I work with children, teens, adults, and caregivers. Each life stage gets a tailored approach — play-based and skill-building work with younger clients, identity and emotion-regulation work with teens, and depth-oriented care with adults.",
      },
      {
        q: "What concerns or conditions do you treat?",
        a: "Common focus areas include anxiety disorders, depression, ADHD and executive functioning, life transitions, relational challenges, self-esteem, and caregiver burnout. I also specialize in neurodiversity-affirming care for autistic clients and those with sensory differences.",
      },
      {
        q: "What is person-centered therapy?",
        a: "Person-centered therapy is grounded in the belief that you are the expert on your own life. My role is to create a safe, genuine, nonjudgmental relationship in which your innate capacity for growth can show up. We don't follow a fixed protocol — therapy is built around your goals and your pace.",
      },
      {
        q: "Do you specialize in neurodivergent clients?",
        a: "Yes. I provide neurodiversity-affirming care that honors how your brain actually works — rather than trying to mask or 'fix' it. We focus on self-awareness, self-compassion, and practical strategies that fit your real life, especially around ADHD, autism, and sensory experiences.",
      },
      {
        q: "Do you offer couples or family therapy?",
        a: "I offer family-system work and caregiver support sessions. For couples-specific therapy I'm happy to provide a referral within my partner network so your care matches the right specialty.",
      },
      {
        q: "Which modalities do you draw from?",
        a: "Every client is different, so I tailor my approach to your unique needs, goals, and preferences. In addition to my primary therapeutic methods, I may incorporate mindfulness, Acceptance and Commitment Therapy (ACT), Solution-Focused Therapy, Motivational Interviewing, trauma-informed care, self-compassion practices, behavioral activation, psychoeducation, stress management techniques, strengths-based interventions, and wellness strategies. My goal is to provide personalized, evidence-based care that supports lasting emotional well-being and meaningful personal growth.",
      },
    ],
  },
  {
    id: "logistics",
    title: "Logistics & Telehealth",
    blurb:
      "Where, when, and how we meet — including telehealth and in-person options.",
    icon: "Globe",
    items: [
      {
        q: "Do you offer telehealth, in-person, or both?",
        a: "Both. Telehealth sessions are conducted through a secure, HIPAA-compliant video platform. In-person sessions are available at the office at 65 E Sunbridge Drive, Fayetteville, AR 72703.",
      },
      {
        q: "What do I need for a telehealth session?",
        a: "A reliable internet connection, a device with a camera and microphone, and a private space where you can speak openly. I'll send a secure link before each session — no extra software to install.",
      },
      {
        q: "Where is the office located?",
        a: "65 E Sunbridge Drive, Fayetteville, AR 72703. Parking is available on site.",
      },
      {
        q: "Are evening or weekend appointments available?",
        a: "Limited evening slots are available for working adults and school-age clients. Weekend availability is rare but possible on a case-by-case basis. Let me know what you need during scheduling.",
      },
    ],
  },
  {
    id: "fees-insurance",
    title: "Fees, Insurance & Policies",
    blurb:
      "Transparent answers about cost, insurance, and cancellations.",
    icon: "ClipboardCheck",
    items: [
      {
        q: "How much do sessions cost?",
        a: "Current rates are shared during the free consultation and adjusted for session length. Please reach out via the contact form and I'll send a full fee schedule.",
      },
      {
        q: "Do you accept insurance?",
        a: "I can provide a superbill (a detailed receipt) that you may submit to your insurance for potential out-of-network reimbursement. I recommend checking with your insurer about your out-of-network mental health benefits before we begin.",
      },
      {
        q: "Is a sliding scale available?",
        a: "A limited number of reduced-fee slots are available based on financial need. Please ask during the consultation — I want cost not to be the reason someone stays in survival mode.",
      },
      {
        q: "What is your cancellation policy?",
        a: "Cancellations made at least 24 hours in advance are free. Late cancellations or missed sessions are billed at the full session rate. Life happens — I'll always try to find a reschedule slot when possible.",
      },
    ],
  },
  {
    id: "privacy-care",
    title: "Privacy & Confidentiality",
    blurb:
      "How your privacy is protected and the limits required by law.",
    icon: "Lock",
    items: [
      {
        q: "Is what I share confidential?",
        a: "Yes. Everything you share is protected under HIPAA and Arkansas state law. I do not share information about you with anyone — including family members — without your written permission.",
      },
      {
        q: "Are there any limits to confidentiality?",
        a: "Yes, a few legally required limits: if there is a credible risk of imminent harm to yourself or another person, suspected abuse or neglect of a child, elder, or dependent adult, or if a court orders the release of records. I'll always walk you through these limits in our first session.",
      },
      {
        q: "What about parents of teen clients?",
        a: "Teens get the privacy they need to actually open up, while parents stay informed about safety and overall progress. We'll set clear expectations together at the start so everyone knows what is and isn't shared.",
      },
    ],
  },
  {
    id: "for-caregivers",
    title: "For Parents & Caregivers",
    blurb:
      "Common questions from families seeking support for a loved one.",
    icon: "HandHeart",
    items: [
      {
        q: "Will I be involved in my child's therapy?",
        a: "Yes, in age-appropriate ways. With younger children, caregiver involvement is a core part of the work — much of progress happens between sessions, at home. With teens, I balance their need for private space with regular check-ins so you stay informed and equipped.",
      },
      {
        q: "How do I know if my child needs therapy?",
        a: "Some common signs: persistent worry or sadness, frequent meltdowns or shutdowns, school avoidance, sleep changes, sudden withdrawal from friends or activities, or big shifts in mood lasting more than a couple weeks. If you're unsure, the free consultation is a low-pressure way to talk it through.",
      },
      {
        q: "I'm a caregiver running on empty — can I get support too?",
        a: "Absolutely. Caregiver burnout is real and deserves its own space. I offer dedicated caregiver sessions focused on boundaries, replenishment, and the practical skills to keep showing up without losing yourself.",
      },
    ],
  },
];
